import React from 'react';

const getTypeClassName = (type) => {
  switch (type) {
    case 'ACTIVE':
    case 'TRIALING':
      return 'active';
    case 'PAST_DUE':
    case 'UNPAID':
      return 'warning';
    case 'CANCELED':
      return 'danger';
    default:
      return 'warning';
  }
};

const Pill = ({ type, children }) => {
  const typeClassName = getTypeClassName(type);
  const className = `pill ${typeClassName}`;

  return (
    <div>
      <span className={className}>{children}</span>
    </div>
  );
};

export default Pill;
